import { authorizedRequest } from '../../common/request';
import { updateCheckoutItems } from "../../cart/actions/cart-actions"
import paymentAccountActionTypes from './payment-accounts-action-types';
import {getSubscriptionProfile} from "./subscription-plan-actions";

export const showUpdatePaymentAccountDialog = (accountIdForUpdate, paymentAcct) =>
  ({
    type: paymentAccountActionTypes.TOGGLE_PAYMENT_ACCOUNT_DIALOG,
    payload: {
      showDialog: true,
      accountIdForUpdate,
      paymentAcct
    }
  });

export const showAddPaymentAccountDialog = () => ({ type: paymentAccountActionTypes.TOGGLE_PAYMENT_ACCOUNT_DIALOG });

export const hidePaymentAccountDialog = () => ({
  type: paymentAccountActionTypes.HIDE_PAYMENT_ACCOUNT_DIALOG
});

export const addNewPaymentAccountRequest = (dispatch, postBody,callback) => {
  authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct`, postBody, 'POST')
    .then(newPaymentAccount => {
      dispatch(addNewPaymentAccount(newPaymentAccount));
      if(typeof(newPaymentAccount.errors) != null){
          dispatch(hidePaymentAccountDialog());
      }
      if(callback != null && typeof(callback) == "function"){
          callback(newPaymentAccount);
      }
    }).catch(err => {
      dispatch({ type: paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR });
      if(callback != null && typeof(callback) == "function"){
        err.json().then((jsonBody)=> callback(jsonBody));
      }
      console.error(err);
    });
  return { type: paymentAccountActionTypes.ADD_NEW_PAYMENT_ACCOUNT_CALL}
};

export const addNewPaymentAccount = newPaymentAccount => ({ type: paymentAccountActionTypes.ADD_NEW_PAYMENT_ACCOUNT, newPaymentAccount });

export const updatePaymentAccount = (dispatch, putBody, accountId,callback) => {
  authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct/${accountId}`, putBody, 'PUT')
    .then(() => {
      dispatch(hidePaymentAccountDialog());
      dispatch(getPaymentAccounts(dispatch));
      getSubscriptionProfile(dispatch);
      if(callback != null && typeof(callback) == "function"){
          callback(putBody);
      }
    }).catch(err => {
      console.error(err);
      dispatch({ type: paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR });
      if(callback != null && typeof(callback) == "function"){
          err.json().then((jsonBody)=> callback(jsonBody));
      }
  });

  return { type: paymentAccountActionTypes.UPDATE_PAYMENT_ACCOUNT_CALL };
};

export const getPaymentAccounts = (dispatch, currencyCode = "USD", callback) => {
  authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct?currencyCode=${currencyCode||"USD"}`).then(paymentAccounts => {
    const primaryPaymentAcct = paymentAccounts.find(paymentAcct =>  paymentAcct.primaryYn === 'Y');
    if (primaryPaymentAcct) {
      dispatch({
        type: paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS_WITH_PRIMARY,
        payload: { paymentAccounts, primaryPaymentAcct }});
    } else {
      dispatch({
        type: paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS,
        payload: { paymentAccounts }});
    }
    if(callback){
        callback(paymentAccounts)
    }
  }).catch(err => {
    dispatch({ type: paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR });
    console.log(err);
  });

  return {
    type: paymentAccountActionTypes.GET_PAYMENT_ACCOUNTS
  };
};

export const deletePaymentAccount = (dispatch, paymentAcctId) => {
  authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct/${paymentAcctId}`, null, 'DELETE')
    .then(() => {
      dispatch({ type: paymentAccountActionTypes.REMOVE_PAYMENT_ACCOUNT, deletedAccountId: paymentAcctId });
    }).catch(err => {
      dispatch({ type: paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR });
      console.log(err);
    });
  return { type: paymentAccountActionTypes.DELETE_PAYMENT_ACCOUNT };
};

export const setDefaultPaymentAccount = (dispatch, paymentAcct) => {
  authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct/primary/${paymentAcct.id}`, null, 'PUT')
    .then(() => {
        dispatch({ type: paymentAccountActionTypes.SET_DEFAULT_PAYMENT_AND_UPDATE, defaultPayment: paymentAcct });
        dispatch({ type: 'DEFAULT_PAYMENT_CHANGED', defaultPayment: paymentAcct });
        updateCheckoutItems({field:"selectedPaymentAccount",value:paymentAccount});

    }).catch(err => {
        dispatch({ type: paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR });
        console.log(err);
    });
  return { type: paymentAccountActionTypes.SET_DEFAULT_PAYMENT_ACCOUNT };
}

export const setSelectedPaymentAccount  = selectedPaymentAccount => {
  return {
    type: paymentAccountActionTypes.SET_SELECTED_PAYMENT_ACCOUNT,
    selectedPaymentAccount
  };
};


// WEBPACK FOOTER //
// ./src/account/actions/payment-accounts-actions.js